module.exports = __webpack_public_path__ + "static/img/KZ.1aa0e128.svg";